import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/Dubai_Safari.webp';

const Project_one = () => {

  return (
    <>

      <div className='project_1_work' id="workBanner">

        <div className="container project_our_work">

          <div className="heading">
            <h1>Dubai Safari</h1>
          </div>

          <hr></hr>
          <div className='project_section'>
            <div className="project_section_content">
              <h1 className="project_scope">Scope of Work</h1>
              <p>Dubai's flagship wildlife park and conservation centre, spanning over 119 hectares and home to 3,000+ animals from 78
                species. Developed by Dubai Municipality as a world-class eco-tourism and wildlife education destination open to residents
                and visitors year-round.</p>
              <p>MAIN CONTRACTOR : Binladin</p>
              <p>MEP CONTRACTOR : -</p>
              <p>GEMCO SCOPE OF WORKS : CHW works</p>
              {/* <h2 className="project_years">2014 – 2022</h2> */}
            </div>
            <div className='project_1_card'>
              <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
            </div>
          </div>
        </div>
      </div>

    </>

  )
}

export default Project_one